// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
// import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';
import App from './App'
import router from './router'
import axios from 'axios';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import {  Cell, CellGroup , NavBar ,Image as VanImage,Grid, GridItem, Col, Row, RadioGroup, Radio, Popup, Button, Form, Field, Toast, Icon, Collapse, CollapseItem, Loading, Divider, Swipe, SwipeItem, Stepper, GoodsAction, GoodsActionIcon, GoodsActionButton } from 'vant';
import 'vant/lib/index.css';

Vue.use(Grid);
Vue.use(NavBar);
Vue.use(VanImage);
Vue.use(GridItem);
Vue.use(Popup);
Vue.use(Toast)
Vue.use(Button)
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Stepper);
Vue.use(GoodsAction);
Vue.use(Divider);
Vue.use(GoodsActionButton);
Vue.use(GoodsActionIcon);
Vue.use(Collapse);
Vue.use(Icon)
Vue.use(CollapseItem);
Vue.use(Loading);
Vue.use(Form);
Vue.use(Field);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Col);
Vue.use(Row);
Vue.use(ElementUI);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.config.productionTip = false
Vue.prototype.axios = axios;
// Vue.component('downloadExcel', JsonExcel)
/* eslint-disable no-new */
router.beforeEach((to, from, next) => {
  const cleanPath = to.path.split("&")[0]; // 清理 & 后的多余参数
  if (to.path !== cleanPath) {
    next({ path: cleanPath, query: to.query });
  } else {
    next();
  }
  if (to.meta && to.meta.title) {
    document.title = to.meta.title
  } else {
    document.title = '分享'
  }
  next()
})
console.log(process.env.NODE_ENV);
let baseURL = ''
if (process.env.NODE_ENV === 'testing') {
  baseURL = 'https://ceshi.xzypapp.com/'
} else if (process.env.NODE_ENV === 'production') {
  baseURL = 'https://dev.xzypapp.com/'
} else {
  baseURL = '/'
}
// console.log(process.env.BASE_API);
axios.defaults.baseURL = baseURL
axios.defaults.withCredentials = true;
axios.defaults.headers.post['content-type'] = 'application/json;charset=UTF-8';//配置请求头
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js